import { useMutation, useQueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";

import { supabase } from "@/shared/lib/supabase";
import { sentryUtils } from "@/shared/utils/sentry";
import { ASSET_SEARCH_TASK_ID } from "@/shared/constants/assetSearch";
import { useAppContext } from "@/shared/hooks/useAppContext";

export function useSubmitAssetSearch() {
  const { user, person } = useAppContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const estateId = person?.estate_id;
      if (!estateId) throw new Error("Estate ID is required to start a search.");

      const now = new Date().toISOString();
      const { error } = await supabase.from("estate_tasks").upsert(
        {
          estate_id: estateId,
          task_id: ASSET_SEARCH_TASK_ID,
          status: "pending_elayne",
          started_at: now,
          last_active_at: now,
          answers: { submitted_by: user?.user_id },
        },
        { onConflict: "estate_id,task_id" },
      );
      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["moduleProgress"] });
      enqueueSnackbar("Asset search started", { variant: "success" });
    },
    onError: (err) => {
      enqueueSnackbar("Couldn't start asset search. Please try again.", { variant: "error" });
      sentryUtils.captureError(err, "Asset search submission failed", {
        userId: user?.user_id,
        estateId: person?.estate_id,
      });
    },
  });
}
